import React from 'react';
import Dialog from '@mui/material/Dialog';

import type { ISnippet } from 'src/services/api';
import SnippetForm from 'src/pages/landlord/snippets/components/form';

type Props = {
    onClose: () => void;
    snippet?: ISnippet;
}

export default function CreateOrUpdateSnippetModal({
    onClose,
    snippet,
}: Props) {
    return (
        <Dialog
            open
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: '100%',
                    minHeight: '450px',
                }
            }}
        >
            <SnippetForm snippet={snippet} onClose={onClose} />
        </Dialog>
    );
}